import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavService } from 'src/app/_services/nav.service';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  host: { class: 'wrapper' },
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(
    private navService: NavService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
    this.selectedNavItem(null);
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  SetActive(targetElement) {
    this.SetInactive();
    this.AddClass(targetElement);
  }

  SetInactive() {
    const menu = document.getElementsByName('mainParent')[0] as
      | HTMLElement
      | undefined;
    if (!menu) return;
    const items = menu.getElementsByClassName(
      'menu-open'
    ) as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < items.length; i++) {
      this.RemoveClass(items[i]);
    }
  }

  ngOnDestroy() {}

  private RemoveClass(menuOpenTag: HTMLElement) {
    (menuOpenTag.childNodes[0] as HTMLElement).classList.remove('active');
    (menuOpenTag.childNodes[1] as HTMLElement).style.display = 'none';
    menuOpenTag.classList.remove('menu-open');
  }

  public AddClass(target: HTMLElement) {
    const parent = target.parentElement.parentElement;
    const parentName = parent.attributes['name'].nodeValue;
    if (parentName === 'childParent') {
      const parentLi = parent.parentElement;
      parentLi.classList.add('menu-open');
      (parentLi.childNodes[1] as HTMLElement).style.display = 'block';
      (parentLi.childNodes[0] as HTMLElement).classList.add('active');
      this.AddClass(parent);
    }
  }
}
